import { Map } from "immutable";
import { createSelector } from "reselect";

export const getCreditCard = (state) => state.billingPaymentMethod.credit_card;
export const getBillingAddress = (state) => state.billingPaymentMethod.billing_address;
export const getCountryFromBillingAddress = (state) => state.billingPaymentMethod.billing_address.get(`country`);
export const getBillingAddressDraft = (state) => state.forms.drafts.get(`payment_billing_address`);

export const makeCreditCardSelector = () => {
  return createSelector(getCreditCard, (creditCard) => creditCard);
};

export const makeBillingAddressSelector = () => {
  return createSelector(getBillingAddress, getBillingAddressDraft, (billingAddress, billingAddressDraft) => {
    if (Map.isMap(billingAddressDraft) && !billingAddressDraft.isEmpty()) {
      return {
        email: billingAddressDraft.get(`email`),
        name: billingAddressDraft.get(`name`),
        address: billingAddressDraft.get(`address`),
        city: billingAddressDraft.get(`city`),
        region: billingAddressDraft.get(`region`),
        zipCode: billingAddressDraft.get(`zipCode`),
        vatId: billingAddressDraft.get(`vatId`),
        country: billingAddressDraft.get(`country`),
      };
    }

    return {
      email: billingAddress.get(`email`),
      name: billingAddress.get(`name`),
      address: billingAddress.get(`address`),
      city: billingAddress.get(`city`),
      region: billingAddress.get(`region`),
      zipCode: billingAddress.get(`zip_code`),
      vatId: billingAddress.get(`vat_id`),
      country: billingAddress.get(`country`),
    };
  });
};

export const getIsBillingInfoAvailable = createSelector(getBillingAddress, (billingAddress) => {
  return (
    !!billingAddress.get(`email`) ||
    !!billingAddress.get(`name`) ||
    !!billingAddress.get(`address`) ||
    !!billingAddress.get(`city`) ||
    !!billingAddress.get(`region`) ||
    !!billingAddress.get(`zip_code`) ||
    !!billingAddress.get(`vat_id`) ||
    !!billingAddress.get(`country`)
  );
});
